import { call, put, takeLatest } from 'redux-saga/effects';
import { select } from 'redux-saga/effects';
import {
  submitDocSuccess,
  submitDocFailed,
  submitRefiDocsSuccess,
  submitRefiDocsFailed,
  feesError,
  downloadAllSuccess,
  downloadAllFailed,
} from './action';
import { Api } from './api';
import { SUBMIT_DOC, SUBMIT_REFIDOC, SAVE_DOCS_FORM_DATA, SAVE_REFIDOCS_FORM_DATA, DOWNLOAD_ALL, GET_LIEN_HOLDER_INFO } from './types';
import { GET_LIEN_HOLDER_INFO_FAILED, GET_LIEN_HOLDER_INFO_SUCCESS } from '../types';
import { STATE_MAPPER } from '../../components/docs/constants';

function* submitDoc(action) {
  const state = yield select();
  const Error = state.fees.feesError;
  try {
    const { locationInfo, vehicleInfo, transactionInfo, firstBuyerInfo, secondBuyerInfo, firstSellerInfo, secondSellerInfo, insuranceInfo, lienHolderInfo } = state.forms;

    const combinedPayload = {
      ...locationInfo,
      ...vehicleInfo,
      ...transactionInfo,
      ...firstBuyerInfo,
      ...secondBuyerInfo,
      ...firstSellerInfo,
      ...secondSellerInfo,
      ...insuranceInfo,
      ...lienHolderInfo,
    };

    yield put({
      type: SAVE_DOCS_FORM_DATA,
      payload: combinedPayload,
    });

    const response = yield call(Api.submitDoc, combinedPayload);
    if (response?.status === 200) {
      yield put(submitDocSuccess(response.data));
      if (Error) {
        yield put(feesError(Error));
        return;
      }
      if (action.navigate && action.path) {
        action.navigate(action.path);
      }
      else {
        action.navigate('docsOutput');
      }
    } else {
      if (Error) {
        yield put(feesError(Error));
      }
      yield put(submitDocFailed(response?.data?.message || response?.data?.error  || 'Failed to submit docs'));
    }
  } catch (error) {
    if (Error) {
      yield put(feesError(Error));
    }
    yield put(submitDocFailed(error.message || 'Unexpected error Occurred in docs'));
  }
}

function* submitRefiDoc(action) {
  const state = yield select();
  const Error = state.fees.feesError;
  try {
    const { locationInfo, vehicleInfo, transactionInfo, firstOwnerInfo, secondOwnerInfo, lienHolderInfo } = state.forms;

    const combinedPayload = {
      ...locationInfo,
      ...vehicleInfo,
      ...transactionInfo,
      ...firstOwnerInfo,
      ...secondOwnerInfo,
      ...lienHolderInfo,
    };

    yield put({
      type: SAVE_REFIDOCS_FORM_DATA,
      payload: combinedPayload,
    });

    const response = yield call(Api.submitRefiDoc, combinedPayload);
    if (response?.status === 200) {
      yield put(submitRefiDocsSuccess(response.data));
      if (Error) {
        yield put(feesError(Error));
        return;
      }
      if (action.navigate && action.path) {
        action.navigate(action.path);
      }
      else {
        action.navigate('docsOutput');
      }
    } else {
      if (Error) {
        yield put(feesError(Error));
      }
      yield put(submitRefiDocsFailed(response?.data?.message || 'Failed to submit refi docs'));
    }
  } catch (error) {
    if (Error) {
      yield put(feesError(Error));
    }
    yield put(submitRefiDocsFailed(error.message || 'Unexpected error Occurred in refi docs'));
  }
}

function* downloadAll(action) {
  const state = yield select();
  const docsResponse = state.docs.docsResponse;

  const links = document.querySelectorAll('.docs-output-form a');
  let urls = Array.from(links).map(link => link.href);

  // Define valid document extensions
  const validExtensions = ['.pdf', '.docx', '.xlsx', '.txt', '.csv', '.jpg', '.png', '.pptx', '.rtf'];

  // Filter URLs to keep only document URLs (PDF, DOCX, etc.)
  urls = urls.filter(url => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
        // Check if the URL ends with a valid document extension
        const fileExtension = url.substring(url.lastIndexOf('.')).toLowerCase();
        return validExtensions.includes(fileExtension);
    }
    return true;
  });

  const file_urls = urls;
  const pdfBlob = action.payload;
  const transaction_id = docsResponse?.TransactionID || ''

  const formData = new FormData();
  // formData.append("pdfBlob", pdfBlob);
  formData.append("file_urls", JSON.stringify(file_urls));
  formData.append("transaction_id", transaction_id);

  try {
    const response = yield call(Api.downloadAll, formData, pdfBlob);

    if (response?.status === 200) {
      yield put(downloadAllSuccess());
    } else {
      yield put(downloadAllFailed());
    }
  } catch (error) {
    yield put(downloadAllFailed());
  }
}

function* getLienHolderInfo(){
  const state = yield select();
  const State = state.forms.locationInfo.state;

  const RStateMapperAry = Object
    .entries(STATE_MAPPER)
    .map(([key, value]) => [value, key]);

  const RStateMapper = Object.fromEntries(RStateMapperAry)

  const payload = {
    state: RStateMapper[State],
    username: localStorage.getItem('email'),
  }

  try {
    const response = yield call(Api.getLienHolderInfo, payload);

    if (response?.status === 200) {
      yield put({
        type: GET_LIEN_HOLDER_INFO_SUCCESS,
        payload: response.data,
      });
    } else {
      yield put({
        type: GET_LIEN_HOLDER_INFO_FAILED,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_LIEN_HOLDER_INFO_FAILED,
      payload: "Unexpected Error",
    });
  }
}


function* docsSaga() {
  yield takeLatest(SUBMIT_DOC, submitDoc);
  yield takeLatest(SUBMIT_REFIDOC, submitRefiDoc);
  yield takeLatest(DOWNLOAD_ALL, downloadAll);
  yield takeLatest(GET_LIEN_HOLDER_INFO, getLienHolderInfo);
}

export default docsSaga;
